// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ProviderChargemasterItem,
    ProviderChargemasterItemFromJSON,
    ProviderChargemasterItemToJSON,
    TemplateDrugInformation,
    TemplateDrugInformationFromJSON,
    TemplateDrugInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderInstitutionalTemplateServiceLine
 */
export interface ProviderInstitutionalTemplateServiceLine {
    /**
     * The service line item id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    id?: string;
    /**
     * Service line revenue code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f42RevenueCode?: string;
    /**
     * Service line procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f44ProcedureCode?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f44ModifierCodes?: Array<string>;
    /**
     * The from service date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f45FromServiceDate?: string;
    /**
     * The through service date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f45ThroughServiceDate?: string;
    /**
     * The service units
     * OpenAPI data type: {number}
     * @type {number}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f46ServiceUnits?: number;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f47TotalChargeAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    f48NonCoveredChargeAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {TemplateDrugInformation}
     * @type {TemplateDrugInformation}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    x12Drug?: TemplateDrugInformation;
    /**
     * The line item control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    x12ControlNumber?: string;
    /**
     * Service narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    x12Narrative?: string;
    /**
     * The various types of providers defined at the service line level.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    x12ProviderIds?: Array<string>;
    /**
     * The chargemaster item id that enforces the information in the service line
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    chargemasterItemId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderChargemasterItem}
     * @type {ProviderChargemasterItem}
     * @memberof ProviderInstitutionalTemplateServiceLine
     */
    chargemasterItem?: ProviderChargemasterItem;
}

export function ProviderInstitutionalTemplateServiceLineFromJSON(json: any): ProviderInstitutionalTemplateServiceLine {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'f42RevenueCode': !exists(json, 'f42RevenueCode') ? undefined : json['f42RevenueCode'],
            'f44ProcedureCode': !exists(json, 'f44ProcedureCode') ? undefined : json['f44ProcedureCode'],
            'f44ModifierCodes': !exists(json, 'f44ModifierCodes') ? undefined : json['f44ModifierCodes'],
            'f45FromServiceDate': !exists(json, 'f45FromServiceDate') ? undefined : json['f45FromServiceDate'],
            'f45ThroughServiceDate': !exists(json, 'f45ThroughServiceDate') ? undefined : json['f45ThroughServiceDate'],
            'f46ServiceUnits': !exists(json, 'f46ServiceUnits') ? undefined : json['f46ServiceUnits'],
            'f47TotalChargeAmount': !exists(json, 'f47TotalChargeAmount') ? undefined : AmountFromJSON(json['f47TotalChargeAmount']),
            'f48NonCoveredChargeAmount': !exists(json, 'f48NonCoveredChargeAmount') ? undefined : AmountFromJSON(json['f48NonCoveredChargeAmount']),
            'x12Drug': !exists(json, 'x12Drug') ? undefined : TemplateDrugInformationFromJSON(json['x12Drug']),
            'x12ControlNumber': !exists(json, 'x12ControlNumber') ? undefined : json['x12ControlNumber'],
            'x12Narrative': !exists(json, 'x12Narrative') ? undefined : json['x12Narrative'],
            'x12ProviderIds': !exists(json, 'x12ProviderIds') ? undefined : json['x12ProviderIds'],
            'chargemasterItemId': !exists(json, 'chargemasterItemId') ? undefined : json['chargemasterItemId'],
            'chargemasterItem': !exists(json, 'chargemasterItem') ? undefined : ProviderChargemasterItemFromJSON(json['chargemasterItem']),
    };

}

export function ProviderInstitutionalTemplateServiceLineToForm(value?: ProviderInstitutionalTemplateServiceLine): any {
    let jsonVal = ProviderInstitutionalTemplateServiceLineToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderInstitutionalTemplateServiceLineToJSON(value?: ProviderInstitutionalTemplateServiceLine): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'f42RevenueCode': cleanupBlankValuesForBackend(value.f42RevenueCode),
            'f44ProcedureCode': cleanupBlankValuesForBackend(value.f44ProcedureCode),
            'f44ModifierCodes': cleanupBlankValuesForBackend(value.f44ModifierCodes),
            'f45FromServiceDate': cleanupBlankValuesForBackend(value.f45FromServiceDate),
            'f45ThroughServiceDate': cleanupBlankValuesForBackend(value.f45ThroughServiceDate),
            'f46ServiceUnits': cleanupBlankValuesForBackend(value.f46ServiceUnits),
            'f47TotalChargeAmount': AmountToJSON(value.f47TotalChargeAmount),
            'f48NonCoveredChargeAmount': AmountToJSON(value.f48NonCoveredChargeAmount),
            'x12Drug': TemplateDrugInformationToJSON(value.x12Drug),
            'x12ControlNumber': cleanupBlankValuesForBackend(value.x12ControlNumber),
            'x12Narrative': cleanupBlankValuesForBackend(value.x12Narrative),
            'x12ProviderIds': cleanupBlankValuesForBackend(value.x12ProviderIds),
            'chargemasterItemId': cleanupBlankValuesForBackend(value.chargemasterItemId),
            'chargemasterItem': ProviderChargemasterItemToJSON(value.chargemasterItem),
    };
}


